import { useEffect, useState } from "react";
import CustomPaperBox from "../../../components/common/CustomPaperBox";
import AdvisorAvatar from "../../../assets/advisor_avatar.png";
import EntrepreneurAvatar from "../../../assets/enterprenuer_avatar.png";
import CustomModal from "../../../components/common/CustomDialog/CustomModal";

const UserSelection = ({ selectedUser, setSelectedUser }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedUser) {
      setOpen(true);
    }
  }, [selectedUser]);

  const handleSelect = (user) => {
    setSelectedUser(user);
  };

  const handleSubmit = () => {
    if (!selectedUser) return;
    setLoading(true);

    setTimeout(() => {
      setOpen(false);
      setLoading(false);
    }, 500);
  };

  return (
    <CustomModal
      open={open}
      title="Join As"
      width="500px"
      onCancel={() => setOpen(false)}
      onSubmit={handleSubmit}
      submitLabel={loading ? "Saving..." : "Next"}
      cancelLabel="Back"
      disableSubmit={!selectedUser || loading}
    >
      <div className="flex gap-6 justify-center p-4">
        <div
          onClick={() => handleSelect("Advisor")}
          className={`cursor-pointer border rounded-lg p-4 text-center w-40 ${selectedUser === "Advisor" ? "border-blue-200 bg-blue-100" : "border-gray-300 bg-white"
            }`}
        >
          <img src={AdvisorAvatar} alt="Advisor" className="h-20 mx-auto" />
          <p className="mt-2 font-semibold">Advisor</p>
        </div>
        <div
          onClick={() => handleSelect("Entrepreneur")}
          className={`cursor-pointer border rounded-lg p-4 text-center w-40 ${selectedUser === "Entrepreneur" ? "border-blue-200 bg-blue-100" : "border-gray-300 bg-white"
            }`}
        >
          <img src={EntrepreneurAvatar} alt="Entrepreneur" className="h-20 mx-auto" />
          <p className="mt-2 font-semibold">Entrepreneur</p>
        </div>
      </div>
    </CustomModal>
  );
};

export default UserSelection;
